var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgResume = function SvgResume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M22.785 2.667H9.215c-2.248 0-4.07 1.79-4.07 4v18.666c0 2.21 1.822 4 4.07 4h13.57c2.248 0 4.071-1.79 4.071-4V6.667c0-2.21-1.823-4-4.07-4Z",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CDDC",
    d: "M20.071 9.333c.75 0 1.357.597 1.357 1.334 0 .683-.524 1.247-1.199 1.324l-.158.009h-8.142c-.75 0-1.357-.597-1.357-1.333 0-.684.524-1.248 1.199-1.325l.158-.009zm0 5.334c.75 0 1.357.597 1.357 1.333 0 .684-.524 1.247-1.199 1.324l-.158.01h-8.142c-.75 0-1.357-.598-1.357-1.334 0-.684.524-1.247 1.199-1.324l.158-.01zM17.357 20c.75 0 1.357.597 1.357 1.333 0 .684-.524 1.248-1.199 1.325l-.158.009H11.93c-.75 0-1.357-.597-1.357-1.334 0-.683.524-1.247 1.199-1.324L11.93 20h5.428Z"
  })));
};
export default SvgResume;